import * as auth from './auth';
import * as firebase from './firebase';
import * as db from './db';

export {
    auth,
    db,
    firebase,
};


// WEBPACK FOOTER //
// ./src/firebase/index.js